import { Region } from 'constants/shop';
import { CollectionHandles } from './types';

// exposed on every shop config as `commonCollections`
export const COMMON_COLLECTION_HANDLES = {
  bundles: { [Region.DE]: 'probierpakete', [Region.NL]: 'proefpakketten' },
  dogsWetFood: { [Region.DE]: 'fur-hunde-nassfutter', [Region.NL]: 'voor-honden-natvoer' },
  dogsDryFood: { [Region.DE]: 'fur-hunde-trockenfutter', [Region.NL]: 'voor-honden-droogvoer' },
  dogsBarf: {
    [Region.DE]: 'fur-hunde-barf-frische-menus',
    [Region.NL]: 'voor-honden-barf-verse-menus',
  },
  dogsSnacks: { [Region.DE]: 'fur-hunde-snacks', [Region.NL]: 'voor-honden-snacks' },
  dogsGreen: { [Region.DE]: 'fur-hunde-green', [Region.NL]: 'voor-honden-green' },
  dogsSupplements: {
    [Region.DE]: 'fur-hunde-nahrungsergaenzung',
    [Region.NL]: 'voor-honden-voedingssupplementen',
  },
  dogsHealth: { [Region.DE]: 'fur-hunde-gesundheit', [Region.NL]: 'voor-honden-gezondheid' },
  dogsBundles: { [Region.DE]: 'fur-hunde-bundles', [Region.NL]: 'voor-honden-bundels' },
  dogsBestsellers: {
    [Region.DE]: 'fur-hunde-beliebte-produkte',
    [Region.NL]: 'voor-honden-populaire-producten',
  },
  dogsAccessories: { [Region.DE]: 'fur-hunde-zubehor', [Region.NL]: 'voor-honden-accessoires' },
  dogsCare: { [Region.DE]: 'fur-hunde-pflege', [Region.NL]: 'voor-honden-verzorging' },
  dogsSmallBreeds: {
    [Region.DE]: 'fur-hunde-futter-fur-kleine-rassen',
    [Region.NL]: 'voor-honden-voer-voor-kleine-rassen',
  },
  dogsPuppyJunior: {
    [Region.DE]: 'fur-hunde-welpen-und-junghunde',
    [Region.NL]: 'voor-honden-puppys-en-jonge-honden',
  },
  dogsAllProducts: {
    [Region.DE]: 'fur-hunde-alle-produkte',
    [Region.NL]: 'voor-honden-alle-producten',
  },
  catsWetFood: { [Region.DE]: 'fur-katzen-nassfutter', [Region.NL]: 'voor-katten-natvoer' },
  catsDryFood: { [Region.DE]: 'fur-katzen-trockenfutter', [Region.NL]: 'voor-katten-droogvoer' },
  catsBarf: {
    [Region.DE]: 'fur-katzen-barf-frische-menus',
    [Region.NL]: 'voor-katten-barf-verse-menus',
  },
  catsSnacks: { [Region.DE]: 'fur-katzen-snacks', [Region.NL]: 'voor-katten-snacks' },
  catsSupplements: {
    [Region.DE]: 'fur-katzen-nahrungserganzung',
    [Region.NL]: 'voor-katten-voedingssupplementen',
  },
  catsBundles: { [Region.DE]: 'fur-katzen-bundles', [Region.NL]: 'voor-katten-bundels' },
  catsBestsellers: {
    [Region.DE]: 'fur-katzen-beliebte-produkte',
    [Region.NL]: 'voor-katten-populaire-producten',
  },
  catsAccessories: { [Region.DE]: 'fur-katzen-zubehor', [Region.NL]: 'voor-katten-accessoires' },
  catsCare: { [Region.DE]: 'fur-katzen-pflege', [Region.NL]: 'voor-katten-verzorging' },
  catsAllProducts: {
    [Region.DE]: 'fur-katzen-alle-produkte',
    [Region.NL]: 'voor-katten-alle-producten',
  },
} as const satisfies CollectionHandles;

export type CommonCollectionKey = keyof typeof COMMON_COLLECTION_HANDLES;
